import { ThemeColors } from "@insite/mobius/globals/baseTheme";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";

export const fontFamily = "'source-sans-pro', sans-serif";
export const fontFamilyHeading = "'klavika-web', sans-serif";

export const mediaQueriesBP = {
    maxSM: "@media screen and (max-width: 424px)",
    minSM: "@media screen and (min-width: 425px)",

    maxMD: "@media screen and (max-width: 767px)",
    minMD: "@media screen and (min-width: 768px)",

    maxLG: "@media screen and (max-width: 1023px)",
    minLG: "@media screen and (min-width: 1024px)",

    maxXLG: "@media screen and (max-width: 1199px)",
    minXLG: "@media screen and (min-width: 1200px)",

    minMDMaxLg: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};

const primaryColor = "#015583";
const secondaryColor = "#48DCE4";

export const manualStyles = {
    // TODO: Create opti ticket for adjusting current URL regex validation
    headerMobileSelected: `
        background: ${primaryColor}33;
        color: #333;
    `,
};

export const calcInitial = "calc((((100vw - (100vw - var(--width, 0))) - 100%) / 2) * -1)"; // VERNDALE CUSTOMIZATION - Alert Banner

export const colorPalette: RecursivePartial<ThemeColors> = {
    primary: {
        main: primaryColor,
    },
    secondary: {
        main: secondaryColor,
    },
    success: {
        main: "#008768",
    },
    danger: {
        main: "#d83300",
    },
    warning: {
        main: "#d8a800",
    },
    text: {
        main: "#222",
        link: "#015583",
        disabled: "#888B8D",
    },
    common: {
        primaryAlt: {
            main: "#fff",
            contrast: primaryColor,
        },
        background: "#fff",
        border: "#d3d3d3",
        global: {
            white: "#fff",
            black: "#000",
            // Primary
            primary2: "#003755",

            // Secondary
            secondary2: "#ADE8F4",

            // Link
            link2: "#0AA7D5",

            // Grays
            gray01: "#222",
            gray02: "#53565A",
            gray03: "#D3D3D3",
            gray04: "#EFF1F2",
            gray05: "#e5e5e5",
            grayText: "#444444",

            // UI
            uiGreen: "#008768",
            uiRed: "#de3502",
            uiYellow: "#ffcc00",

            // Header
            headerBg: primaryColor,
            rowBg: "#e9ebf1",

            // Client specific colors
        },
    } as any,
};

export const colorStrings = {
    primaryMain: "primary.main",
    secondaryMain: "secondary.main",
    successMain: "success.main",
    dangerMain: "danger.main",
    warningMain: "warning.main",
    infoMain: "info.main",
    commonBackground: "common.background",
    commonBorder: "common.border",
    textMain: "text.main",
    textLink: "text.link",
    textDisabled: "text.disabled",
    common: "common",

    commonPrimaryAlt: "common.primaryAlt",
    commonPrimarySecond: "common.global.primary2",
    commonSecondarySecond: "common.global.secondary2",
    commonGlobalWhite: "common.global.white",
    commonGlobalBlack: "common.global.black",
    commonGlobalGray01: "common.global.gray01",
    commonGlobalGray02: "common.global.gray02",
    commonGlobalGray03: "common.global.gray03",
    commonGlobalGray04: "common.global.gray04",
    commonGlobalGray05: "common.global.gray05",
    commonGlobalHeaderBg: "common.global.headerBg",
    commonGlobalGrayText: "common.global.grayText",
    commonGlobalRowBg: "common.global.rowBg",
};
